import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import { getMerchants } from '../../services/searchService'
import checkIcon from '../../assets/images/Checkmark.png'
import BtnContent from '../../components/BtnContent'
import { IDefaultSortProps } from '../DefaultSort/index'
import { Impression } from 'bxl-analytics'
import { EXCLUDE_MERCHANT } from '../../lib/constants'
let impression
const MerchantSort = (props: IDefaultSortProps) => {
    const { setSearchQuery, q, searchProducts } = props
    const [merchants, setmerchants] = useState<any[]>([])
    const [searchValue, setsearchValue] = useState('#')
    const contentRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        getAllMerchants()
        setTimeout(() => {
            bindImpression()
        }, 3000)
        return () => {
            impression && impression.detach()
        }
    }, [])
    const arr = new Array(26).fill('').map((item, i) => {
        return String.fromCharCode(65 + i)
    })
    arr.unshift('#')
    const classList = arr.map(item => {
        //title# 不能被识别
        if (item === '#') return 'title0'
        return `.title${item}`
    })
    const getAllMerchants = () => {
        let node = contentRef.current
        if (node) {
            node.scrollTop = 0
        }
        getMerchants()
            .then(res => {
                let merchants = res.data?.merchants
                if (window.location.host === 'ewe.santasmartnetwork.com') {
                    merchants = merchants.filter(
                        item => !EXCLUDE_MERCHANT.includes(item.name)
                    )
                }
                let newArr = [{ type: 'line', name: '#' }]
                let reg = /^[0-9]+[\s\S]*$/
                let strObj = {}
                merchants.forEach(async (item, index) => {
                    if (reg.test(item.name)) {
                        newArr.push(item)
                    } else {
                        await arr.forEach(e => {
                            let name = item?.name.toUpperCase()
                            if (name.startsWith(e)) {
                                if (strObj[e]) {
                                    strObj[e].push(item)
                                } else {
                                    strObj[e] = new Array()
                                    strObj[e].push(item)
                                }
                            }
                        })
                    }
                })
                for (let key in strObj) {
                    strObj[key].unshift({ type: 'line', name: key })
                    newArr = newArr.concat(strObj[key])
                }
                setmerchants(newArr)
            })
            .catch(err => {
                console.log(err)
            })
    }
    let isSelect = (id: string) => {
        if (!q.selectMerchants) return false
        return q?.selectMerchants?.indexOf(id) !== -1
    }
    const bindImpression = () => {
        impression = new Impression({
            debounce: 200,
            element: '.merchantAllContent'
        })
        // 滚动距离
        let scrollHeigth = 0
        impression.attach()
        impression.all(classList, nodes => {
            let node = contentRef.current
            let scrollUp
            if (node) {
                scrollUp = node.scrollTop > scrollHeigth ? false : true
                scrollHeigth = node.scrollTop
            }
            let activeNode = nodes[nodes.length - 1]
            if (activeNode) {
                let key = activeNode.key.substring(activeNode.key.length - 1)
                if (scrollUp) {
                    key = arr[arr.findIndex(e => e === key)]
                }
                setsearchValue(key)
            }
        })
    }
    const chooseMerchant = id => {
        let eIndex = q?.selectMerchants?.indexOf(id)
        let eMerchants = q?.selectMerchants ? [...q?.selectMerchants] : []
        if (eIndex !== -1) {
            eMerchants.splice(eIndex, 1)
        } else {
            eMerchants.push(id)
        }
        setSearchQuery('selectMerchants', eMerchants)
    }
    const resetQuery = () => {
        setSearchQuery('selectMerchants', [])
    }
    const clickText = text => {
        let node: HTMLElement | null = document.querySelector(
            `.title${text === '#' ? '0' : text}`
        )
        let scrollNode = contentRef.current
        let scrollHeight = node ? node.offsetTop : 0
        if (scrollNode) scrollNode.scrollTop = scrollHeight
        setsearchValue(text)
    }
    return (
        <>
            {merchants.length > 0 && (
                <div className="merchantAllContent" ref={contentRef}>
                    <div className="letterList">
                        {arr.map((item, index) => {
                            return (
                                <div
                                    key={`merchant${index}`}
                                    onClick={() => clickText(item)}
                                    className={`charCode ${
                                        searchValue === item ? 'active' : ''
                                    }`}
                                >
                                    {item}
                                </div>
                            )
                        })}
                    </div>
                    {merchants.map((item, index) => {
                        if (item.type === 'line') {
                            return (
                                <div
                                    className={`merchantTitle title${item.name}`}
                                    key={`title${index}`}
                                >
                                    {item.name}
                                </div>
                            )
                        }
                        return (
                            <div
                                className="merchantItem"
                                key={`merchantItem${index}`}
                            >
                                <img
                                    className="merchantIcon"
                                    src={item?.images?.[0]?.full?.url}
                                ></img>
                                <div
                                    className={`merchantName ${
                                        isSelect(item.id) ? 'active' : ''
                                    }`}
                                    onClick={() => chooseMerchant(item.id)}
                                >
                                    <img
                                        className="merchantSource"
                                        src={item?.merchantInfo?.merchantUrl}
                                        alt=""
                                    ></img>
                                    {item.name}
                                </div>
                                {isSelect(item.id) && (
                                    <img
                                        className="checkIcon"
                                        src={checkIcon}
                                        alt=""
                                    ></img>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}
            <BtnContent
                resetQuery={resetQuery}
                sureSearch={searchProducts}
            ></BtnContent>
        </>
    )
}

export default MerchantSort
